"use client";

import React from "react";

import { createSVGIcon } from "./util";

/**
 * @trackcomponent
 * @optimized using svgo:^3.0.2
 */
export const CrownIcon = createSVGIcon(
  <path
    d="M16.881 6.561 11.998 0l-4.88 6.561L0 3.875 2.784 17h18.432L24 3.875z"
    fill="currentColor"
  />,
  "CrownIcon",
  {
    viewBox: "0 -3 24 24",
    width: "24",
    height: "24",
    color: "#29A7B8",
  }
);

/** @optimized using svgo:^3.0.2 */
export const CircledCrownIcon = createSVGIcon(
  <>
    <path
      d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
      stroke="currentColor"
    />
    <path
      d="M14.557 11.104 11.999 7.43l-2.556 3.675L5.714 9.6 7.173 16h9.655l1.458-6.4z"
      stroke="currentColor"
      fill="#fff"
    />
  </>,
  "CircledCrownIcon",
  {
    viewBox: "0 0 24 24",
    width: "24",
    height: "24",
    fill: "none",
  }
);

/** @optimized using svgo:^3.0.2 */
export const DashedCircledCrownIcon = createSVGIcon(
  <>
    <path
      d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
      stroke="currentColor"
      strokeDasharray="2 2"
    />
    <path
      d="M14.557 11.104 11.999 7.43l-2.556 3.675L5.714 9.6 7.173 16h9.655l1.458-6.4z"
      fill="currentColor"
    />
  </>,
  "DashedCircledCrownIcon",
  {
    viewBox: "0 0 24 24",
    width: "24",
    height: "24",
    fill: "none",
  }
);
